import { VUwebSearchService, Query } from "@/shared/services/azure-search-service";
import AzureSearchMapper from "../mappings/azure-search-mapper";

class SearchService {
    private mapper = new AzureSearchMapper();

    constructor() {}

    public search(query: Query, service: VUwebSearchService): Promise<any> {
        return new Promise((resolve, reject) => {
            service.search(query).then((response: any) => {
                resolve(this.mapper.mapSearchResults(response));
            }).catch((error: any) => {
                reject(error);
            });
        });
    }
}

export default new SearchService();